import { createContext } from "react";
import { StickyBannerData } from "app/pages/AppDashboard/components/StickyBanner/StickyBanner";

interface BreadcrumbsContextInterface {
	setBreadcrumbLinks: (a: any[]) => void;
	breadcrumbTitle: string;
	setShowBreadcrumb: (a: boolean) => void;
	setBreadcrumbDropdownBtn: (a: any[]) => void;
	setBreadcrumbTitle: (a: string | null) => void;
	setBreadcrumbButtons: (a: any[]) => void;
	setActionButton: (a: any) => void;
	setStickyBannerData: (bannerData: StickyBannerData | null) => void;
	stickyBannerData: StickyBannerData | null;
}

const BreadcrumbsContext = createContext<BreadcrumbsContextInterface>({
	setBreadcrumbLinks: () => {},
	breadcrumbTitle: "",
	setShowBreadcrumb: () => {},
	setBreadcrumbDropdownBtn: () => {},
	setBreadcrumbTitle: () => {},
	setBreadcrumbButtons: () => {},
	setActionButton: () => {},
	setStickyBannerData: () => {},
	stickyBannerData: null
});

BreadcrumbsContext.displayName = "BreadcrumbsContext";

export default BreadcrumbsContext;
